import React, { useState } from "react";
import {
	Modal,
	Paper,
	Typography,
	Box,
	Button,
	Select,
	MenuItem,
	FormControl,
} from "@mui/material";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import CancelIcon from "@mui/icons-material/Cancel";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CircularProgress from "@mui/material/CircularProgress";

const FileUploadModal = ({
	open,
	onClose,
	folders,
	onUpload,
	currentFolderPath = "",
}) => {
	const [selectedFolder, setSelectedFolder] = useState("");
	const [files, setFiles] = useState([]);
	const [uploading, setUploading] = useState(false);

	const handleFileSelect = (event) => {
		if (event.target.files) {
			setFiles(Array.from(event.target.files));
		}
	};
	const handleClose = () => {
		setFiles([]);
		setSelectedFolder("");
		onClose();
	};
	const handleUpload = async () => {
		if (!files.length) return;

		setUploading(true);
		try {
			const formData = new FormData();

			files.forEach((file) => {
				formData.append("files", file);
			});

			// Add folder path if selected
			if (selectedFolder) {
				formData.append("folderPath", `Folders/${selectedFolder}`);
			} else if (currentFolderPath) {
				formData.append("folderPath", currentFolderPath);
			}

			await onUpload(formData);
			handleClose();
		} catch (error) {
			console.error("Upload error:", error);
		} finally {
			setUploading(false);
		}
	};
	return (
		<Modal open={open} onClose={handleClose}>
			<Paper
				sx={{
					width: "50%",
					padding: 3,
					margin: "auto",
					marginTop: "6%",
					outline: "none",
					overflowY: "auto",
					maxHeight: "700px",
				}}>
				<Typography variant='h6' fontWeight='bold'>
					New Document
				</Typography>
				{!currentFolderPath && folders && folders.length !== 0 && (
					<FormControl fullWidth sx={{ marginTop: 3 }}>
						<Select
							value={selectedFolder}
							onChange={(e) => setSelectedFolder(e.target.value)}
							IconComponent={ExpandMoreRoundedIcon}
							displayEmpty
							renderValue={(selected) =>
								selected || "Select a folder (OPTIONAL)"
							}>
							{folders.map((folder, index) => (
								<MenuItem key={index} value={folder.name}>
									{folder.name}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				)}

				{/* File Upload Section */}
				<Box
					sx={{
						textAlign: "center",
						marginTop: 3,
						padding: 2,
						backgroundColor: "#f3e8ff",
						borderRadius: 2,
						border: "1px dotted grey",
						height: "293px",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						cursor: "pointer",
					}}>
					{/* Label to trigger file input */}
					<label htmlFor='file-upload' style={{ cursor: "pointer" }}>
						<CloudUploadRoundedIcon
							sx={{ fontSize: "100px", color: "#000" }}
						/>
					</label>

					<Typography variant='h6' fontWeight='bold'>
						Drop or select file
					</Typography>

					<Typography variant='subtitle1' color='textSecondary'>
						Drop files here or click to{" "}
						<label
							htmlFor='file-upload'
							style={{
								color: "blue",
								cursor: "pointer",
								textDecoration: "underline",
							}}>
							browse
						</label>{" "}
						through your desktop
					</Typography>

					{/* Hidden File Input */}
					<input
						type='file'
						style={{ display: "none" }}
						id='file-upload'
						multiple
						hidden
						onChange={handleFileSelect}
					/>
				</Box>
				{files.length > 0 &&
					files.map((file, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								alignItems: "center",
								padding: "8px 12px",
								borderRadius: "8px",
								border: "1px solid #ddd",
								width: "100%",
								justifyContent: "space-between",
								marginTop: 2,
							}}>
							{/* Left Side - Icon and File Name */}
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									gap: "8px",
								}}>
								<DescriptionRoundedIcon
									sx={{ color: "blue", fontSize: 34 }}
								/>
								<Typography
									variant='body2'
									sx={{
										fontWeight: "bold",
										color: "black",
										textDecoration: "none",
										cursor: "pointer",
									}}>
									{file.name}
								</Typography>
								<Typography
									variant='caption'
									sx={{
										color: "gray",
										marginLeft: "20px",
										fontSize: "15px",
									}}>
									{Math.floor(file.size / 1000)} Kb
								</Typography>
							</Box>

							{/* Right Side - File Size & Remove Icon */}
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									gap: "8px",
								}}>
								<CancelIcon
									sx={{
										cursor: "pointer",
										color: "gray",
										fontSize: 25,
									}}
									onClick={() =>
										setFiles(
											files.filter((_, i) => i !== index)
										)
									}
								/>
							</Box>
						</Box>
					))}

				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						marginTop: 3,
					}}>
					<Button
						variant='contained'
						sx={{ background: "blue" }}
						startIcon={<FileUploadOutlinedIcon />}
						disabled={files.length === 0}
						onClick={handleUpload}>
						{uploading ? (
							<CircularProgress color='inherit' size='30px' />
						) : (
							"Upload"
						)}
					</Button>
				</Box>
			</Paper>
		</Modal>
	);
};
export default FileUploadModal;
